exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-single-document{display:flex;gap:10px;align-items:center;justify-content:flex-start}.customer-single-document__actions{flex-grow:1;display:flex;align-items:center;justify-content:flex-end;gap:10px}", ""]);

// exports
